"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
const typography_1 = __importDefault(require("../typography/typography"));
require("../../styles/components/link-button.less");
const LinkButton = ({ variant, text, className, onClick, disabled, color }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)(`link-button ${className}`, { disabled }), onClick: disabled ? noop_1.default : onClick },
    react_1.default.createElement(typography_1.default, { variant: variant, color: color }, text)));
LinkButton.defaultProps = {
    color: undefined,
    variant: 'body1',
    onClick: noop_1.default,
    text: '',
    className: '',
    disabled: false,
};
LinkButton.propTypes = {
    color: prop_types_1.default.string,
    variant: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    text: prop_types_1.default.string,
    className: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
};
exports.default = LinkButton;
//# sourceMappingURL=link-button.js.map